import React from 'react';

import {
	ErrorWrapper,
	Title,
	ErrorType,
	Description,
	Button,
} from './AuthenticationError.styles';

const AuthenticationError = ({ errorType, errorDescription, onClick }) => (
	<ErrorWrapper>
		<Title>Oh!</Title>
		<ErrorType>{errorType}</ErrorType>
		<Description>{errorDescription}</Description>
		<Button onClick={onClick}>Try Again</Button>
	</ErrorWrapper>
);

export default AuthenticationError;
